// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2lpGG","name":"ConsentHeader_name__2U5Nh","birthday":"ConsentHeader_birthday__1ITEJ","skeleton":"ConsentHeader_skeleton__2Ptgm"};